#import "../fragments/subdomain-fragment.graphql"

query GetSubdomains($includeNutshellManaged: Boolean) {
    subdomains(includeNutshellManaged: $includeNutshellManaged) {
        ...SubdomainFragment
    }
}
